module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UvZl51/tc-custom/9781685504267.jpg?1723405445835",
      "alt": "This image is the cover for the book In Tune"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("In Tune\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In college, Paxton Barrilla and Mars Hudson built a strong foundation for lifelong friendship. Then their careers take them to opposite sides of the country. When they walk into a recording studio in Las Vegas, Pax as producer and Mars as clarinet player, they haven’t seen each other for almost twenty years."), _c('br'), _c('br'), _vm._v("At first, Pax’s plans are simply to make the best jazz record he possibly can. Mars? He wants that, too. But what he wants more is a chance to see if long-ago friendship and a gift for working together might add up to more."), _c('br'), _c('br'), _vm._v("The overture is a surprise, but Pax is interested. After three weeks of the kinds of conversations they never had with anyone else, are they ready to see if they’ve struck the right chord?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alexandra Caluen\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0